import { CalculatorRequestType, ICalculatorType } from '../../../shared';

/**
 * Generates first Menu item element, of which should label dropdown items
 */
export const genDDMenuItemLabel = (label?: string): JSX.Element => {
  return (
    <li>
      <span className="dropdown-item" aria-label={label} tabIndex={-1}>
        {label ? label : 'Label not found'}
      </span>
    </li>
  );
};


export function getCalculatorRequestType(calcRequest: ICalculatorType[]): CalculatorRequestType {
  const selected = calcRequest.filter((item) => item.isSelected);
  if (selected.length !== 1) {
    return 'NONE';
  }
  return calcRequest[0].calculatorType === 'TTLCalculatorYes' ? 'CALC' : 'NO_CALC';
}
